import { useEffect, useState } from "react";

// ui
import { Box } from "@mui/material";

// Chart
import { SaleCompanyChart } from "../component/SaleCompanyChart";
import { SaleCompanyBulkSettingModal } from "../component/SaleCompanyBulkSettingModal";

// Table
import { ConstTable } from "../component/Table";

// Bar
import TableTopBar from "../component/TableTopBar";
import SerchSideBar from "../component/SerchSideBar";
import AiChatSideBar from "../component/AiChatSideBar";

// Modal
import { DataDetailModal } from "../component/detail/DataDetailModal";
import { DataEditModal } from "../component/DataEditModal";
import { DataAddModal } from "../component/DataAddModal";
import { DataAddModalResult } from "../component/DataAddModalResult";

// jotai
import { useAtomValue, useSetAtom } from "jotai";
import { AppAtoms } from "../lib/store";

// API
import {
  getSaleCompanys,
  getSaleCompany,
  putSaleCompany,
  postSaleCompany,
} from "../api/saleCompany";
import {
  getSaleCompanyUniquePayments,
  getSaleCompanyUniquePayment,
  putSaleCompanyUniquePayment,
  postSaleCompanyUniquePayment,
} from "../api/saleCompanyUniquePayment";
import {
  getSaleCompanyGroups,
  putSaleCompanyGroup,
  postSaleCompanyGroup,
} from "../api/saleCompanyGroup";
import { getSaleCompanyPublishPaymentExcels } from "../api/saleCompanyPublishPaymentExcel";
import {
  getSaleCompanyTossUpProducts,
  postSaleCompanyTossUpProducts,
} from "../api/saleCompanyTossUpProduct";
import {
  getSaleCompanyTossUpProductCloserCompanys,
  postSaleCompanyTossUpProductCloserCompanys,
} from "../api/saleCompanyTossUpProductCloserCompany";
import {
  getSaleCompanyEntryProducts,
  postSaleCompanyEntryProducts,
} from "../api/saleCompanyEntryProduct";
import {
  getSaleCompanyCollaborateCompanys,
  postSaleCompanyCollaborateCompanys,
} from "../api/saleCompanyCollaborateCompany";
import {
  getSaleCompanyGroupClosingCategorys,
  postSaleCompanyGroupClosingCategorys,
} from "../api/saleCompanyGroupClosingCategory";
import {
  getSerchSaleCompanys,
  getSerchSaleCompanyGroups,
  getSerchProducts,
} from "../api/serch";

// InterFace
import { saleCompanyTableColumn } from "../config/saleCompany";
import {
  dataDifine,
  subDataDifine,
  EditDataDifine,
} from "../config/dataInterface";

// OtherFunc
import { getFirstYear, getOneYear } from "../lib/other";
import { CONST } from "../config/const";

function SaleCompany() {
  const setIsLoading = useSetAtom(AppAtoms.isLoading);
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const loginUser = useAtomValue(AppAtoms.loginUser);

  // 各権限毎のヘッダーメニューの編集
  const addDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "パートナー登録",
    },
  ];
  const addCSVDataTypes: { auth: string[]; name: string }[] = [];
  const getXLSXDataTypes: { auth: string[]; name: string }[] = [];
  const editDatasTypes: { auth: string[]; name: string }[] = [];

  const [addDataNames, setAddDataNames] = useState<string[]>([]);
  const [addDataName, setAddDataName] = useState<string>("");
  const [addCSVDataNames, setAddCSVDataNames] = useState<string[]>([]);
  const [addCSVDataName, setAddCSVDataName] = useState<string>("");
  const [getXLSXDataNames, setGetXLSXDataNames] = useState<string[]>([]);
  const [getXLSXDataName, setGetXLSXDataName] = useState<string>("");
  const [editDatasNames, setEditDatasNames] = useState<string[]>([]);
  const [editDatasName, setEditDatasName] = useState<string>("");
  const [bulkSettingOpen, setBulkSettingOpen] = useState("");
  const [showBulkSetting, setShowBulkSetting] = useState(false);
  const [aiChatOpen, setAiChatOpen] = useState(false);

  // 体制図
  const [tableOriginalFunc, setTableOriginalFunc] = useState<{
    name: string;
    key: { [key: string]: string };
  }>({ name: "", key: {} });
  const [chartSaleCompanyId, setChartSaleCompanyId] = useState<string | null>(null);
  const [chartSaleCompanyName, setChartSaleCompanyName] = useState<string | null>(null);
  useEffect(() => {
    if (tableOriginalFunc.name === "体制図" && tableOriginalFunc.key.id) {
      setChartSaleCompanyId(tableOriginalFunc.key.id);
      setChartSaleCompanyName(tableOriginalFunc.key.sale_company_name ?? "");
    }
  }, [tableOriginalFunc.name, tableOriginalFunc.key]);

  useEffect(() => {
    let addDataNames: string[] = [];
    let addCSVDataNames: string[] = [];
    let getXLSXDataNames: string[] = [];
    let editDatasNames: string[] = [];
    addDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        addDataNames.push(dataType.name);
      }
    });
    setAddDataNames(addDataNames);
    addCSVDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        addCSVDataNames.push(dataType.name);
      }
    });
    setAddCSVDataNames(addCSVDataNames);
    getXLSXDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        getXLSXDataNames.push(dataType.name);
      }
    });
    setGetXLSXDataNames(getXLSXDataNames);
    editDatasTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        editDatasNames.push(dataType.name);
      }
    });
    setEditDatasNames(editDatasNames);
    setShowBulkSetting(
      loginUser?.authority === "マスターアカウント" ||
      loginUser?.authority === "スタッフアカウント"
    );
  }, [loginUser]);

  // 排他制御: 検索とAIチャットは同時に開かない
  const handleSetSerchOpen = (open: boolean) => {
    setSerchOpen(open);
    if (open) setAiChatOpen(false);
  };
  const handleSetAiChatOpen = (open: boolean) => {
    setAiChatOpen(open);
    if (open) setSerchOpen(false);
  };
  const BULK_SETTING_NAMES = showBulkSetting
    ? ["エントリー商材", "トスアップ商材", "トスアップ商材 - 指定クロージングパートナー", "グループ - クロージングカテゴリー", "協業パートナー"]
    : [];
  const BULK_SETTING_NAME_TO_TYPE: Record<string, "entry" | "tossup" | "closing_partner" | "closing_category" | "collaborate"> = {
    "エントリー商材": "entry",
    "トスアップ商材": "tossup",
    "トスアップ商材 - 指定クロージングパートナー": "closing_partner",
    "グループ - クロージングカテゴリー": "closing_category",
    "協業パートナー": "collaborate",
  };

  useEffect(() => {
    if (addDataName === "パートナー登録") {
      setOnDataAddModal(true);
    }
  }, [addDataName]);

  useEffect(() => {}, [addCSVDataName]);

  // サブテーブルデータの一覧取得
  const [getSubTableName, setGetSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  useEffect(() => {
    if (
      getSubTableName.name === "発行済明細一覧" ||
      getSubTableName.name === "明細一覧"
    ) {
      getSubtableDataPublishPaymentExcel();
    }
    if (getSubTableName.name === "グループ一覧") {
      getSubtableDataSaleCompanyGroup();
    }
    if (getSubTableName.name === "明細独自単価一覧") {
      getSubtableDataSaleCompanyUniquePayment();
    }
    if (getSubTableName.name === "トスアップ商材一覧") {
      getSubtableDataTossUpProduct();
    }
    if (getSubTableName.name === "エントリー商材一覧") {
      getSubtableDataEntryProduct();
    }
    if (getSubTableName.name === "協業パートナー一覧") {
      getSubtableDataCollaborateCompany();
    }
  }, [getSubTableName.name, getSubTableName.key]);

  // サブテーブルデータの詳細取得
  const [getSubTableDetail, setGetSubTableDetail] = useState<{
    name: string;
    key: { [key: string]: string };
    dataDetail: {
      [key: string]:
        | number
        | string
        | { [key: string]: string | number }[]
        | { [key: string]: string | string[] };
    } | null;
  }>({
    name: "",
    key: {},
    dataDetail: null,
  });
  useEffect(() => {
    if (getSubTableDetail.name === "パートナー明細独自単価詳細") {
      getSubtableDataDetailSaleCompanyUniquePayment();
    }
  }, [getSubTableDetail.name, getSubTableDetail.key]);

  // サブテーブルデータの登録
  const [getSubTableAdd, setGetSubTableAdd] = useState<{
    name: string;
    row: dataDifine | null;
  }>({
    name: "",
    row: null,
  });
  useEffect(() => {
    if (getSubTableAdd.name === "グループ追加") {
      openModalSubtableDataAddSaleCompanyGroup();
    }
    if (getSubTableAdd.name === "明細独自単価追加") {
      openModalSubtableDataAddSaleCompanyUniquePayment();
    }
    if (getSubTableAdd.name === "トスアップ商材追加") {
      openModalSubtableDataAddTossUpProduct();
    }
    if (getSubTableAdd.name === "エントリー商材追加") {
      openModalSubtableDataAddEntryProduct();
    }
    if (getSubTableAdd.name === "協業パートナー追加") {
      openModalSubtableDataAddCollaborateCompany();
    }
  }, [getSubTableAdd.name, getSubTableAdd.row]);

  // サブサブテーブルデータの一覧取得
  const [getSubSubTableName, setGetSubSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  useEffect(() => {
    if (getSubSubTableName.name === "指定 - クロージングパートナー一覧") {
      getSubSubtableDataTossUpProductCloserCompany();
    }
    if (getSubSubTableName.name === "クロージングカテゴリー一覧") {
      getSubSubtableDataGroupClosingCategory();
    }
  }, [getSubSubTableName.name, getSubSubTableName.key]);

  // サブテーブルデータの登録
  const [getSubSubTableAdd, setGetSubSubTableAdd] = useState<{
    name: string;
    row: dataDifine | null;
  }>({
    name: "",
    row: null,
  });
  useEffect(() => {
    if (getSubSubTableAdd.name === "指定 - クロージングパートナー追加") {
      openModalSubSubtableDataAddTossUpProductCloserCompany();
    }
    if (getSubSubTableAdd.name === "クロージングカテゴリー追加") {
      openModalSubSubtableDataAddGroupClosingCategory();
    }
  }, [getSubSubTableAdd.name, getSubSubTableAdd.row]);

  // 検索欄、テーブル等の高さ
  const [tableHeight, setTableHeight] = useState("calc(100vh - 110px)");
  useEffect(() => {
    const tableHeight = isSmartPhone
      ? "calc(100vh - 190px)"
      : "calc(100vh - 110px)";
    setTableHeight(tableHeight);
  }, [isSmartPhone]);
  const [serchOpen, setSerchOpen] = useState(false);

  const firstYear = getFirstYear();
  const { thisYear, thisMonth, lastYear, lastMonth } = getOneYear();

  // 表示数・ページ
  const [displayNumber, setDisplayNumber] = useState(50);
  const displayNumbers = [25, 50, 100, 250, 500];
  const [pageNumber, setPageNumber] = useState(1);
  const [maxPageNumber, setMaxPageNumber] = useState(1);

  // 検索項目
  const serchColumn = saleCompanyTableColumn.dataColumn.reduce(
    (column, difine) => {
      if (difine.serch === true) {
        if (difine.serchType === "date") {
          return {
            ...column,
            [difine.key + "_start"]: "",
            [difine.key + "_end"]: "",
          };
        } else if (difine.serchType === "payment_year_month") {
          return {
            ...column,
            payment_year: thisYear.toString(),
            payment_month: thisMonth.toString(),
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
          };
        }
      } else {
        return {
          ...column,
        };
      }
    },
    {}
  );
  const [serchString, setSerchString] = useState(serchColumn);
  const [serchStringView, setSerchStringView] = useState(serchColumn);

  // 検索用 - パートナー一覧・グループ一覧・商材一覧
  const [companyNameList, setCompanyNameList] = useState<string[]>([]);
  const [companyGroupNameList, setCompanyGroupNameList] = useState<string[]>(
    []
  );
  const [productNameList, setProductNameList] = useState<string[]>([""]);
  async function getSaleCompanysList() {
    const fetchData = await getSerchSaleCompanys();
    if (fetchData == null) {
      setCompanyNameList([]);
    } else if (fetchData?.saleCompanys) {
      const nameList = [""];
      fetchData.saleCompanys.forEach(
        (c: { id: number; sale_company_name: string }) => {
          if (!nameList.includes(c.sale_company_name)) {
            nameList.push(c.sale_company_name);
          }
        }
      );
      setCompanyNameList(nameList);
    }
  }
  async function getSaleCompanyGroupsList() {
    const fetchData = await getSerchSaleCompanyGroups();
    if (fetchData == null) {
      setCompanyGroupNameList([]);
    } else if (fetchData?.saleCompanyGroups) {
      const nameList = [""];
      fetchData.saleCompanyGroups.forEach(
        (g: { id: number; group_name: string }) => {
          if (!nameList.includes(g.group_name)) {
            nameList.push(g.group_name);
          }
        }
      );
      setCompanyGroupNameList(nameList);
    }
  }
  async function getProductList() {
    const fetchData = await getSerchProducts();
    if (fetchData == null) {
      setProductNameList([""]);
    } else if (fetchData?.products) {
      const nameList = [""];
      fetchData.products.forEach(
        (p: { id: number; high_rank_company_id?: number; product_name: string }) => {
          if (!nameList.includes(p.product_name)) {
            nameList.push(p.product_name);
          }
        }
      );
      setProductNameList(nameList);
    }
  }
  useEffect(() => {
    getSaleCompanysList();
    getSaleCompanyGroupsList();
    getProductList();
  }, []);

  // テーブルデータ
  const [fetchData, setFetchData] = useState<dataDifine[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  async function getTableData(edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const fetchData = await getSaleCompanys({
      ...serchString,
      displayNumber,
      pageNumber,
    });
    if (fetchData === null) {
      setFetchData([]);
      setTotalCount(0);
      setMaxPageNumber(1);
      setPageNumber(1);
    } else if (fetchData) {
      setFetchData(fetchData.saleCompanys);
      const countSaleCompanys = Number(fetchData.countSaleCompanys);
      setTotalCount(countSaleCompanys);
      setMaxPageNumber(Math.ceil(countSaleCompanys / displayNumber));
    }
    if (!edit) {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    getTableData(false);
  }, [serchString, displayNumber, pageNumber]);

  // データ詳細
  const [dataDetail, setDataDetail] = useState<{
    [key: string]: number | string | { [key: string]: string | number }[];
  } | null>(null);

  async function getDataDetail(key: { [key: string]: string }, edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const id = key.id;
    const { detail_data, option_data } = await getSaleCompany(id);
    setDataDetail({
      ...detail_data,
      option_data,
    });
    if (!edit) {
      setIsLoading(false);
    }
  }

  // データ編集
  const [editData, setEditData] = useState<EditDataDifine | null>(null);
  async function putEditData() {
    if (editData !== null) {
      setIsLoading(true);
      const id = editData.tableId as string;
      setEditData({
        ...editData,
        status: "editing",
      });
      const putResponce = await putSaleCompany(editData);
      await getDataDetail({ id }, true);
      await getTableData(true);
      setEditData({
        ...editData,
        status: putResponce,
      });
      setIsLoading(false);
    }
  }

  // データ新規作成
  const addDataColumns = saleCompanyTableColumn.dataColumn.reduce(
    (column, difine) => {
      if (difine.add) {
        if (difine.addType === "date") {
          return {
            ...column,
            [difine.key + "_year"]: thisYear.toString(),
            [difine.key + "_month"]: thisMonth.toString(),
            [difine.key + "_date"]: "1",
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
          };
        }
      } else {
        return {
          ...column,
        };
      }
    },
    {}
  );
  const [addData, setAddData] = useState<{
    [key: string]: string | boolean | any[];
  }>(addDataColumns);
  const [onDataAddModal, setOnDataAddModal] = useState(false);
  const [onDataAddModalResult, setOnDataAddModalResult] = useState("");
  async function postAddData() {
    setIsLoading(true);
    setOnDataAddModal(false);
    const postResponce = await postSaleCompany(addData);
    if (postResponce === "success") {
      await getTableData(true);
      setAddData(addDataColumns);
      setOnDataAddModalResult("success");
    } else {
      setOnDataAddModal(true);
      setOnDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // サブテーブルデータの登録結果（共通）
  const [onSubtableDataAddModalResult, setOnSubtableDataAddModalResult] =
    useState("");

  // 代理店-発行済明細エクセル一覧取得
  async function getSubtableDataPublishPaymentExcel() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getSaleCompanyPublishPaymentExcels(
        getSubTableName.key.id
      );
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // 代理店-グループ一覧取得
  async function getSubtableDataSaleCompanyGroup() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getSaleCompanyGroups(getSubTableName.key.id);
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // 代理店-グループ編集
  const [editDataDetailSaleCompanyGroup, setEditDataDetailSaleCompanyGroup] =
    useState<EditDataDifine | null>(null);
  async function putEditDataDetailSaleCompanyGroup() {
    if (editDataDetailSaleCompanyGroup !== null) {
      setIsLoading(true);
      setEditDataDetailSaleCompanyGroup({
        ...editDataDetailSaleCompanyGroup,
        status: "editing",
      });
      const putResponce = await putSaleCompanyGroup(
        editDataDetailSaleCompanyGroup
      );
      if (putResponce == "success") {
        await getSubtableDataSaleCompanyGroup();
      }
      setEditDataDetailSaleCompanyGroup({
        ...editDataDetailSaleCompanyGroup,
        status: putResponce,
      });
      setIsLoading(false);
    }
  }

  // 代理店-グループ新規登録
  const addDataColumnsSaleCompanyGroup =
    saleCompanyTableColumn.subTable[2].subDataColumn.reduce(
      (column, difine) => {
        if (difine.add) {
          if (difine.addType === "date") {
            return {
              ...column,
              [difine.key + "_year"]: thisYear.toString(),
              [difine.key + "_month"]: thisMonth.toString(),
              [difine.key + "_date"]: "1",
            };
          } else {
            return {
              ...column,
              [difine.key]: "",
            };
          }
        } else {
          return {
            ...column,
          };
        }
      },
      {}
    );
  const [addDataSaleCompanyGroup, setAddDataSaleCompanyGroup] = useState<{
    [key: string]: string | boolean | any[];
  }>(addDataColumnsSaleCompanyGroup);
  const [onDataAddModalSaleCompanyGroup, setOnDataAddModalSaleCompanyGroup] =
    useState(false);
  async function openModalSubtableDataAddSaleCompanyGroup() {
    let _addDataSaleCompanyGroup = addDataSaleCompanyGroup;
    saleCompanyTableColumn.subTable[2].subDataColumn.map((difine) => {
      if (difine.add && getSubTableAdd.row) {
        if (difine.addType === "tableId") {
          _addDataSaleCompanyGroup[difine.key] =
            getSubTableAdd.row.id.toString();
        } else if (difine.addType === "tableSubId") {
          _addDataSaleCompanyGroup[difine.key] =
            getSubTableAdd.row[difine.key].toString();
        } else if (difine.addType === "tableData") {
          _addDataSaleCompanyGroup[difine.key] = getSubTableAdd.row[
            difine.key
          ] as string;
        }
      }
    });
    setAddDataSaleCompanyGroup(_addDataSaleCompanyGroup);
    if (getSubTableAdd.row) {
      setOnDataAddModalSaleCompanyGroup(true);
    }
  }
  async function postAddDataSaleCompanyGroup() {
    setIsLoading(true);
    setOnDataAddModalSaleCompanyGroup(false);
    const postResponce = await postSaleCompanyGroup(addDataSaleCompanyGroup);
    if (postResponce === "success") {
      await getTableData(true);
      if (getSubTableName.key.id) {
        await getSubtableDataSaleCompanyGroup();
      }
      setAddDataSaleCompanyGroup(addDataColumnsSaleCompanyGroup);
      setOnSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalSaleCompanyGroup(true);
      setOnSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // 代理店-独自単価一覧取得
  async function getSubtableDataSaleCompanyUniquePayment() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getSaleCompanyUniquePayments(
        getSubTableName.key.id
      );
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // 代理店-独自単価詳細取得
  async function getSubtableDataDetailSaleCompanyUniquePayment() {
    if (getSubTableDetail.key.id) {
      setIsLoading(true);
      const dataDetail = await getSaleCompanyUniquePayment(
        getSubTableDetail.key.id
      );
      setGetSubTableDetail({
        ...getSubTableDetail,
        dataDetail,
      });
      setIsLoading(false);
    }
  }

  // 代理店-独自単価編集
  const [
    editDataDetailSaleCompanyUniquePayment,
    setEditDataDetailSaleCompanyUniquePayment,
  ] = useState<EditDataDifine | null>(null);
  async function putEditDataDetailSaleCompanyUniquePayment() {
    if (editDataDetailSaleCompanyUniquePayment !== null) {
      setIsLoading(true);
      setEditDataDetailSaleCompanyUniquePayment({
        ...editDataDetailSaleCompanyUniquePayment,
        status: "editing",
      });
      const putResponce = await putSaleCompanyUniquePayment(
        editDataDetailSaleCompanyUniquePayment
      );
      if (putResponce == "success") {
        await getSubtableDataSaleCompanyUniquePayment();
        await getSubtableDataDetailSaleCompanyUniquePayment();
      }
      setEditDataDetailSaleCompanyUniquePayment({
        ...editDataDetailSaleCompanyUniquePayment,
        status: putResponce,
      });
      setIsLoading(false);
    }
  }

  // 代理店-独自単価新規登録
  const addDataColumnsSaleCompanyUniquePayment =
    saleCompanyTableColumn.subTable[3].subDataColumn.reduce(
      (column, difine) => {
        if (difine.add) {
          if (difine.addType === "date") {
            return {
              ...column,
              [difine.key + "_year"]: thisYear.toString(),
              [difine.key + "_month"]: thisMonth.toString(),
              [difine.key + "_date"]: "1",
            };
          } else {
            return {
              ...column,
              [difine.key]: "",
            };
          }
        } else {
          return {
            ...column,
          };
        }
      },
      {}
    );
  const [addDataSaleCompanyUniquePayment, setAddDataSaleCompanyUniquePayment] =
    useState<{
      [key: string]: string | boolean | any[];
    }>(addDataColumnsSaleCompanyUniquePayment);
  const [
    onDataAddModalSaleCompanyUniquePayment,
    setOnDataAddModalSaleCompanyUniquePayment,
  ] = useState(false);
  async function openModalSubtableDataAddSaleCompanyUniquePayment() {
    let _addDataSaleCompanyUniquePayment = addDataSaleCompanyUniquePayment;
    saleCompanyTableColumn.subTable[3].subDataColumn.map((difine) => {
      if (difine.add && getSubTableAdd.row) {
        if (difine.addType === "tableId") {
          _addDataSaleCompanyUniquePayment[difine.key] =
            getSubTableAdd.row.id.toString();
        } else if (difine.addType === "tableSubId") {
          _addDataSaleCompanyUniquePayment[difine.key] =
            getSubTableAdd.row[difine.key].toString();
        } else if (difine.addType === "tableData") {
          _addDataSaleCompanyUniquePayment[difine.key] = getSubTableAdd.row[
            difine.key
          ] as string;
        }
      }
    });
    setAddDataSaleCompanyUniquePayment(_addDataSaleCompanyUniquePayment);
    if (getSubTableAdd.row) {
      setOnDataAddModalSaleCompanyUniquePayment(true);
    }
  }
  async function postAddDataSaleCompanyUniquePayment() {
    setIsLoading(true);
    setOnDataAddModalSaleCompanyUniquePayment(false);
    const postResponce = await postSaleCompanyUniquePayment(
      addDataSaleCompanyUniquePayment
    );
    if (postResponce === "success") {
      await getTableData(true);
      if (getSubTableName.key.id) {
        await getSubtableDataSaleCompanyUniquePayment();
      }
      setAddDataSaleCompanyUniquePayment(
        addDataColumnsSaleCompanyUniquePayment
      );
      setOnSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalSaleCompanyUniquePayment(true);
      setOnSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // トスアップ商材一覧取得
  async function getSubtableDataTossUpProduct() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getSaleCompanyTossUpProducts(
        getSubTableName.key.id
      );
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // トスアップ商材登録
  const [addDataTossUpProduct, setAddDataTossUpProduct] = useState<{
    [key: string]: string | boolean | any[];
  }>({
    sale_company_id: "",
    all_product: [],
    select_product: [],
  });
  const [onDataAddModalTossUpProduct, setOnDataAddModalTossUpProduct] =
    useState(false);
  async function openModalSubtableDataAddTossUpProduct() {
    if (getSubTableAdd.row) {
      setIsLoading(true);
      const fetchData = await getSaleCompanyTossUpProducts(
        getSubTableAdd.row.id as string
      );
      setAddDataTossUpProduct({
        sale_company_id: getSubTableAdd.row.id as string,
        all_product: fetchData.productDatas,
        select_product: fetchData.sudDatas,
      });
      setOnDataAddModalTossUpProduct(true);
      setIsLoading(false);
    }
  }
  async function postAddDataTossUpProduct() {
    setIsLoading(true);
    setOnDataAddModalTossUpProduct(false);
    const postResponce = await postSaleCompanyTossUpProducts(
      addDataTossUpProduct
    );
    if (postResponce === "success") {
      if (getSubTableName.name == "トスアップ商材一覧") {
        await getSubtableDataTossUpProduct();
      }
      setIsLoading(true);
      await getTableData(true);
      setAddDataTossUpProduct({
        sale_company_id: "",
        all_product: [],
        select_product: [],
      });
      setOnSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalTossUpProduct(true);
      setOnSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // エントリー商材一覧取得
  async function getSubtableDataEntryProduct() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getSaleCompanyEntryProducts(
        getSubTableName.key.id
      );
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // エントリー商材登録
  const [addDataEntryProduct, setAddDataEntryProduct] = useState<{
    [key: string]: string | boolean | any[];
  }>({
    sale_company_id: "",
    all_product: [],
    select_product: [],
  });
  const [onDataAddModalEntryProduct, setOnDataAddModalEntryProduct] =
    useState(false);
  async function openModalSubtableDataAddEntryProduct() {
    if (getSubTableAdd.row) {
      setIsLoading(true);
      const fetchData = await getSaleCompanyEntryProducts(
        getSubTableAdd.row.id as string
      );
      setAddDataEntryProduct({
        sale_company_id: getSubTableAdd.row.id as string,
        all_product: fetchData.productDatas,
        select_product: fetchData.sudDatas,
      });
      setOnDataAddModalEntryProduct(true);
      setIsLoading(false);
    }
  }
  async function postAddDataEntryProduct() {
    setIsLoading(true);
    setOnDataAddModalEntryProduct(false);
    const postResponce = await postSaleCompanyEntryProducts(
      addDataEntryProduct
    );
    if (postResponce === "success") {
      if (getSubTableName.name == "エントリー商材一覧") {
        await getSubtableDataEntryProduct();
      }
      setIsLoading(true);
      await getTableData(true);
      setAddDataEntryProduct({
        sale_company_id: "",
        all_product: [],
        select_product: [],
      });
      setOnSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalEntryProduct(true);
      setOnSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // 協業パートナー一覧取得
  async function getSubtableDataCollaborateCompany() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getSaleCompanyCollaborateCompanys(
        getSubTableName.key.id
      );
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // 協業パートナー一覧登録
  const [addDataCollaborateCompany, setAddDataCollaborateCompany] = useState<{
    [key: string]: string | boolean | any[];
  }>({
    sale_company_id: "",
    all_collaborate_company: [],
    select_collaborate_company: [],
  });
  const [
    onDataAddModalCollaborateCompany,
    setOnDataAddModalCollaborateCompany,
  ] = useState(false);
  async function openModalSubtableDataAddCollaborateCompany() {
    if (getSubTableAdd.row) {
      setIsLoading(true);
      const fetchData = await getSaleCompanyCollaborateCompanys(
        getSubTableAdd.row.id as string
      );
      setAddDataCollaborateCompany({
        sale_company_id: getSubTableAdd.row.id as string,
        all_collaborate_company: fetchData.collaborateCompanys,
        select_collaborate_company: fetchData.sudDatas,
      });
      setOnDataAddModalCollaborateCompany(true);
      setIsLoading(false);
    }
  }
  async function postAddDataCollaborateCompany() {
    setIsLoading(true);
    setOnDataAddModalCollaborateCompany(false);
    const postResponce = await postSaleCompanyCollaborateCompanys(
      addDataCollaborateCompany
    );
    if (postResponce === "success") {
      if (getSubTableName.name == "協業パートナー一覧") {
        await getSubtableDataCollaborateCompany();
      }
      setIsLoading(true);
      await getTableData(true);
      setAddDataCollaborateCompany({
        sale_company_id: "",
        all_product: [],
        select_product: [],
      });
      setOnSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalCollaborateCompany(true);
      setOnSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }
  // サブサブテーブルデータの登録結果（共通）
  const [onSubSubtableDataAddModalResult, setOnSubSubtableDataAddModalResult] =
    useState("");

  // トスアップ商材 - クロージングパートナー一覧取得
  async function getSubSubtableDataTossUpProductCloserCompany() {
    if (getSubSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getSaleCompanyTossUpProductCloserCompanys(
        getSubSubTableName.key.id
      );
      setGetSubSubTableName({
        ...getSubSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // トスアップ商材 - クロージングパートナー登録
  const [
    addDataTossUpProductCloserCompany,
    setAddDataTossUpProductCloserCompany,
  ] = useState<{
    [key: string]: string | boolean | any[];
  }>({
    sale_company_toss_up_product_id: "",
    all_closer_company: [],
    select_closer_company: [],
  });
  const [
    onDataAddModalTossUpProductCloserCompany,
    setOnDataAddModalTossUpProductCloserCompany,
  ] = useState(false);
  async function openModalSubSubtableDataAddTossUpProductCloserCompany() {
    if (getSubSubTableAdd.row) {
      setIsLoading(true);
      const fetchData = await getSaleCompanyTossUpProductCloserCompanys(
        getSubSubTableAdd.row.id as string
      );
      setAddDataTossUpProductCloserCompany({
        sale_company_toss_up_product_id: getSubSubTableAdd.row.id as string,
        all_closer_company: fetchData.closer_company_data,
        select_closer_company: fetchData.sudDatas,
        current_sale_company_id: String(getSubSubTableAdd.row.sale_company_id),
      });
      setOnDataAddModalTossUpProductCloserCompany(true);
      setIsLoading(false);
    }
  }
  async function postAddDataTossUpProductCloserCompany() {
    setIsLoading(true);
    setOnDataAddModalTossUpProductCloserCompany(false);
    const postResponce = await postSaleCompanyTossUpProductCloserCompanys(
      addDataTossUpProductCloserCompany
    );
    if (postResponce === "success") {
      if (getSubTableName.name == "トスアップ商材一覧") {
        await getSubtableDataTossUpProduct();
      }
      if (getSubSubTableName.name == "指定 - クロージングパートナー一覧") {
        await getSubSubtableDataTossUpProductCloserCompany();
      }
      setIsLoading(true);
      await getTableData(true);
      setAddDataTossUpProductCloserCompany({
        sale_company_toss_up_product_id: "",
        all_closer_company: [],
        select_closer_company: [],
      });
      setOnSubSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalTossUpProductCloserCompany(true);
      setOnSubSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // 代理店グループ-クロージングカテゴリー一覧取得
  async function getSubSubtableDataGroupClosingCategory() {
    if (getSubSubTableName.key.id && getSubSubTableName.key.sale_company_id) {
      setIsLoading(true);
      const fetchData = await getSaleCompanyGroupClosingCategorys(
        getSubSubTableName.key.id,
        getSubSubTableName.key.sale_company_id as string
      );
      setGetSubSubTableName({
        ...getSubSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // 代理店グループ-クロージングカテゴリー一覧登録
  const [addDataGroupClosingCategory, setAddDataGroupClosingCategory] =
    useState<{
      [key: string]: string | boolean | any[];
    }>({
      sale_company_group_id: "",
      all_category: [],
      select_category: [],
    });
  const [
    onDataAddModalGroupClosingCategory,
    setOnDataAddModalGroupClosingCategory,
  ] = useState(false);
  async function openModalSubSubtableDataAddGroupClosingCategory() {
    if (getSubSubTableAdd.row) {
      setIsLoading(true);
      const fetchData = await getSaleCompanyGroupClosingCategorys(
        getSubSubTableAdd.row.id as string,
        getSubSubTableAdd.row.sale_company_id as string
      );
      setAddDataGroupClosingCategory({
        sale_company_group_id: getSubSubTableAdd.row.id as string,
        all_category: fetchData.categoryDatas,
        select_category: fetchData.sudDatas,
      });
      setOnDataAddModalGroupClosingCategory(true);
      setIsLoading(false);
    }
  }
  async function postAddDataGroupClosingCategory() {
    setIsLoading(true);
    setOnDataAddModalGroupClosingCategory(false);
    const postResponce = await postSaleCompanyGroupClosingCategorys(
      addDataGroupClosingCategory
    );
    if (postResponce === "success") {
      if (getSubTableName.name == "グループ一覧") {
        await getSubtableDataSaleCompanyGroup();
      }
      if (getSubSubTableName.name == "クロージングカテゴリー一覧") {
        await getSubSubtableDataGroupClosingCategory();
      }
      setIsLoading(true);
      await getTableData(true);
      setAddDataGroupClosingCategory({
        sale_company_group_id: "",
        all_category: [],
        select_category: [],
      });
      setOnSubSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalGroupClosingCategory(true);
      setOnSubSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  return (
    <Box
      style={{
        width: isSmartPhone
          ? "calc(100% - 31px)"
          : (serchOpen || aiChatOpen)
          ? "calc(100% - 331px)"
          : "calc(100% - 31px)",
        height: isSmartPhone ? "calc(100vh - 120px)" : "calc(100vh - 40px)",
      }}
    >
      <TableTopBar
        serch={true}
        serchOpen={serchOpen}
        setSerchOpen={handleSetSerchOpen}
        addDataNames={addDataNames}
        addDataName={addDataName}
        setAddDataName={setAddDataName}
        addCSVDataNames={addCSVDataNames}
        addCSVDataName={addCSVDataName}
        setAddCSVDataName={setAddCSVDataName}
        getXLSXDataNames={getXLSXDataNames}
        getXLSXDataName={getXLSXDataName}
        setGetXLSXDataName={setGetXLSXDataName}
        editDatasNames={editDatasNames}
        editDatasName={editDatasName}
        setEditDatasName={setEditDatasName}
        editIDs={[]}
        columnSettingOpen={false}
        openColumnSettingWindow={() => {}}
        bulkSettingNames={BULK_SETTING_NAMES}
        bulkSettingName={bulkSettingOpen}
        setBulkSettingName={setBulkSettingOpen}
        aiChatOpen={aiChatOpen}
        setAiChatOpen={handleSetAiChatOpen}
      />
      <Box style={{ display: "flex" }}>
        {(serchOpen || aiChatOpen) && isSmartPhone ? null : (
          <Box
            style={{
              width: isSmartPhone ? undefined : "100%",
              margin: isSmartPhone ? undefined : "10px 15px",
              height: isSmartPhone ? undefined : tableHeight,
              maxHeight: isSmartPhone ? undefined : tableHeight,
            }}
          >
            <ConstTable
              getTableData={getTableData}
              tableType={"main"}
              serchOpen={serchOpen}
              aiChatOpen={aiChatOpen}
              tableHeight={tableHeight}
              tableColumn={saleCompanyTableColumn}
              dataColumn={[]}
              rows={fetchData}
              displayNumber={displayNumber}
              setDisplayNumber={setDisplayNumber}
              displayNumbers={displayNumbers}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              maxPageNumber={maxPageNumber}
              totalCount={totalCount}
              getDataDetail={getDataDetail}
              getSubTableName={getSubTableName}
              setGetSubTableName={setGetSubTableName}
              getSubTableDetail={getSubTableDetail}
              setGetSubTableDetail={setGetSubTableDetail}
              setGetSubTableAdd={setGetSubTableAdd}
              setGetSubTableEditDirect={setEditDataDetailSaleCompanyGroup}
              getSubSubTableName={getSubSubTableName}
              setGetSubSubTableName={setGetSubSubTableName}
              getSubSubTableDetail={{
                name: "",
                key: {},
                dataDetail: null,
              }}
              setGetSubSubTableDetail={() => {}}
              setGetSubSubTableAdd={setGetSubSubTableAdd}
              setGetSubSubTableEditDirect={() => {}}
              tableTitle={
                loginUser?.authority === "パートナー"
                  ? "企業・グループ一覧"
                  : saleCompanyTableColumn.title
              }
              switchTableCheckBox={() => {}}
              allCheckFlg={false}
              switchAllTableCheckBox={() => {}}
              editIDs={[]}
              setEditIDs={() => {}}
              setEditDatasName={setEditDatasName}
              setGetSubMainTableName={() => {}}
              setTableOriginalFunc={setTableOriginalFunc}
              sortColumn={[]}
              setSortColumn={() => {}}
            />
          </Box>
        )}
        {serchOpen ? (
          <SerchSideBar
            setSerchOpen={handleSetSerchOpen}
            tableHeight={tableHeight}
            tableColumn={saleCompanyTableColumn}
            dataColumn={[]}
            firstYear={firstYear}
            thisYear={thisYear}
            serchColumn={serchColumn}
            setSerchString={setSerchString}
            companyNameList={companyNameList}
            companyGroupNameList={companyGroupNameList}
            highRankCompanyNameList={[]}
            categoryNameList={[]}
            productNameList={productNameList}
            accountSaleNameList={[]}
            accountStaffNameList={[]}
            serchStringView={serchStringView}
            setSerchStringView={setSerchStringView}
          />
        ) : null}
        {aiChatOpen && (
          <AiChatSideBar
            open={aiChatOpen}
            setOpen={handleSetAiChatOpen}
            pageName="SaleCompany"
          />
        )}
      </Box>
      <DataDetailModal
        onModal={
          dataDetail !== null &&
          ((editData !== null && editData.status !== "editing") ||
            editData === null)
        }
        swCloseModal={() => setDataDetail(null)}
        detailTitle={saleCompanyTableColumn.detailTitle}
        editAuth={saleCompanyTableColumn.editAuth}
        dataColumn={saleCompanyTableColumn.dataColumn}
        subDataColumn={[]}
        dataDetail={dataDetail}
        setEditData={setEditData}
        option={false}
        setEditProduct={() => {}}
        dataDetailOption={[]}
        dataDetailOptionSelect={[]}
        dataDetailHistory={[]}
        selectHistory={0}
        getOldDataDetail={() => {}}
        getGroupList={() => {}}
        setEditProductOptionPlans={() => {}}
        setEditProductOptionContents={() => {}}
        setEditTossUpFormOptionProducts={() => {}}
        setEditOutsideServices={() => {}}
        setSelectServiseInfo={() => {}}
        setSelectTossUpInfo={() => {}}
      />
      <DataEditModal
        onModal={editData !== null && editData.status !== "editing"}
        swCloseModal={() => setEditData(null)}
        editData={editData}
        setEditData={setEditData}
        putEditData={putEditData}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataAddModal
        onModal={onDataAddModal}
        swCloseModal={() => {
          setOnDataAddModal(false);
          setAddDataName("");
        }}
        addTitle={saleCompanyTableColumn.addTitle}
        dataColumn={saleCompanyTableColumn.dataColumn}
        subDataColumn={[]}
        postAddData={postAddData}
        addData={addData}
        setAddData={setAddData}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModalResult
        onModal={onDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnDataAddModalResult("");
          setAddDataName("");
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onDataAddModalResult}
      />
      <DataDetailModal
        onModal={
          getSubTableDetail.name ===
            saleCompanyTableColumn.subTable[3].subTableDetailTitle &&
          getSubTableDetail.dataDetail !== null &&
          ((editDataDetailSaleCompanyUniquePayment !== null &&
            editDataDetailSaleCompanyUniquePayment.status !== "editing") ||
            editDataDetailSaleCompanyUniquePayment === null)
        }
        swCloseModal={() =>
          setGetSubTableDetail({
            name: "",
            key: {},
            dataDetail: null,
          })
        }
        detailTitle={saleCompanyTableColumn.subTable[3].subTableDetailTitle}
        editAuth={saleCompanyTableColumn.subTable[3].subTableEditAuth}
        dataColumn={[]}
        subDataColumn={saleCompanyTableColumn.subTable[3].subDataColumn}
        dataDetail={getSubTableDetail.dataDetail}
        setEditData={setEditDataDetailSaleCompanyUniquePayment}
        option={false}
        setEditProduct={() => {}}
        dataDetailOption={[]}
        dataDetailOptionSelect={[]}
        dataDetailHistory={[]}
        selectHistory={0}
        getOldDataDetail={() => {}}
        getGroupList={() => {}}
        setEditProductOptionPlans={() => {}}
        setEditProductOptionContents={() => {}}
        setEditTossUpFormOptionProducts={() => {}}
        setEditOutsideServices={() => {}}
        setSelectServiseInfo={() => {}}
        setSelectTossUpInfo={() => {}}
      />
      <DataEditModal
        onModal={
          editDataDetailSaleCompanyGroup !== null &&
          editDataDetailSaleCompanyGroup.status !== "editing"
        }
        swCloseModal={() => setEditDataDetailSaleCompanyGroup(null)}
        editData={editDataDetailSaleCompanyGroup}
        setEditData={setEditDataDetailSaleCompanyGroup}
        putEditData={putEditDataDetailSaleCompanyGroup}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataEditModal
        onModal={
          editDataDetailSaleCompanyUniquePayment !== null &&
          editDataDetailSaleCompanyUniquePayment.status !== "editing"
        }
        swCloseModal={() => setEditDataDetailSaleCompanyUniquePayment(null)}
        editData={editDataDetailSaleCompanyUniquePayment}
        setEditData={setEditDataDetailSaleCompanyUniquePayment}
        putEditData={putEditDataDetailSaleCompanyUniquePayment}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataAddModal
        onModal={onDataAddModalSaleCompanyGroup}
        swCloseModal={() => {
          setOnDataAddModalSaleCompanyGroup(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={saleCompanyTableColumn.subTable[2].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={saleCompanyTableColumn.subTable[2].subDataColumn}
        postAddData={postAddDataSaleCompanyGroup}
        addData={addDataSaleCompanyGroup}
        setAddData={setAddDataSaleCompanyGroup}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModal
        onModal={onDataAddModalSaleCompanyUniquePayment}
        swCloseModal={() => {
          setOnDataAddModalSaleCompanyUniquePayment(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={saleCompanyTableColumn.subTable[3].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={saleCompanyTableColumn.subTable[3].subDataColumn}
        postAddData={postAddDataSaleCompanyUniquePayment}
        addData={addDataSaleCompanyUniquePayment}
        setAddData={setAddDataSaleCompanyUniquePayment}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModal
        onModal={onDataAddModalTossUpProduct}
        swCloseModal={() => {
          setOnDataAddModalTossUpProduct(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={saleCompanyTableColumn.subTable[4].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={saleCompanyTableColumn.subTable[4].subDataColumn}
        postAddData={postAddDataTossUpProduct}
        addData={addDataTossUpProduct}
        setAddData={setAddDataTossUpProduct}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModal
        onModal={onDataAddModalEntryProduct}
        swCloseModal={() => {
          setOnDataAddModalEntryProduct(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={saleCompanyTableColumn.subTable[5].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={saleCompanyTableColumn.subTable[5].subDataColumn}
        postAddData={postAddDataEntryProduct}
        addData={addDataEntryProduct}
        setAddData={setAddDataEntryProduct}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModal
        onModal={onDataAddModalCollaborateCompany}
        swCloseModal={() => {
          setOnDataAddModalCollaborateCompany(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={saleCompanyTableColumn.subTable[6].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={saleCompanyTableColumn.subTable[6].subDataColumn}
        postAddData={postAddDataCollaborateCompany}
        addData={addDataCollaborateCompany}
        setAddData={setAddDataCollaborateCompany}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModalResult
        onModal={onSubtableDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnSubtableDataAddModalResult("");
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onSubtableDataAddModalResult}
      />
      <DataAddModal
        onModal={onDataAddModalTossUpProductCloserCompany}
        swCloseModal={() => {
          setOnDataAddModalTossUpProductCloserCompany(false);
          setGetSubSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={
          saleCompanyTableColumn.subTable[4].subTable[0].subTableAddTitle
        }
        dataColumn={[]}
        subDataColumn={
          saleCompanyTableColumn.subTable[4].subTable[0].subDataColumn
        }
        postAddData={postAddDataTossUpProductCloserCompany}
        addData={addDataTossUpProductCloserCompany}
        setAddData={setAddDataTossUpProductCloserCompany}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModal
        onModal={onDataAddModalGroupClosingCategory}
        swCloseModal={() => {
          setOnDataAddModalGroupClosingCategory(false);
          setGetSubSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={
          saleCompanyTableColumn.subTable[2].subTable[0].subTableAddTitle
        }
        dataColumn={[]}
        subDataColumn={
          saleCompanyTableColumn.subTable[2].subTable[0].subDataColumn
        }
        postAddData={postAddDataGroupClosingCategory}
        addData={addDataGroupClosingCategory}
        setAddData={setAddDataGroupClosingCategory}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModalResult
        onModal={onSubSubtableDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnSubSubtableDataAddModalResult("");
          setGetSubSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onSubSubtableDataAddModalResult}
      />
      <SaleCompanyChart
        onModal={chartSaleCompanyId !== null}
        swCloseModal={() => {
          setChartSaleCompanyId(null);
          setChartSaleCompanyName(null);
          setTableOriginalFunc({ name: "", key: {} });
          if (getSubTableName.name === "グループ一覧") {
            getSubtableDataSaleCompanyGroup();
          }
        }}
        saleCompanyId={chartSaleCompanyId ?? ""}
        saleCompanyName={chartSaleCompanyName ?? ""}
      />
      <SaleCompanyBulkSettingModal
        open={bulkSettingOpen !== ""}
        onClose={() => setBulkSettingOpen("")}
        onSaveSuccess={() => getTableData(false)}
        settingType={BULK_SETTING_NAME_TO_TYPE[bulkSettingOpen] ?? "entry"}
      />
    </Box>
  );
}

export default SaleCompany;
